var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09522 11.036C4.14769 7.49979 6.22096 3.90878 9.75721 2.96124C13.2935 2.01371 16.8845 4.08698 17.832 7.62323L18.4922 10.0872C18.8014 11.241 19.5706 12.2695 20.58 12.8599C21.6989 13.3876 22.4457 14.4673 22.7538 15.617L23.0318 16.6545C23.1685 17.1646 23.1211 17.6772 22.872 18.1087C22.6229 18.5401 22.2026 18.8375 21.6925 18.9742L7.42742 22.7965C6.91732 22.9332 6.40466 22.8858 5.97319 22.6367C5.54173 22.3876 5.24438 21.9673 5.1077 21.4572L4.82971 20.4197C4.51139 19.2318 4.68442 18.0699 5.32223 16.9652C5.91067 15.946 6.06664 14.6614 5.75544 13.5L5.09522 11.036ZM10.0427 4.0266C7.0948 4.81648 5.3707 7.80271 6.16058 10.7506L6.8208 13.2145C7.20457 14.6468 7.01805 16.2338 6.2774 17.5167C5.77601 18.3851 5.65741 19.2473 5.89507 20.1343L6.17306 21.1717C6.24487 21.4397 6.38062 21.5984 6.52466 21.6815C6.6687 21.7647 6.87396 21.8029 7.14195 21.7311L21.407 17.9088C21.675 17.837 21.8337 17.7012 21.9168 17.5572C22 17.4132 22.0382 17.2079 21.9664 16.9399L21.6884 15.9025C21.4427 14.9855 20.8641 14.2062 20.0929 13.8497C20.0778 13.8427 20.063 13.835 20.0485 13.8267C18.7657 13.0861 17.8106 11.8049 17.4269 10.3727L16.7666 7.90869C15.9768 4.96082 12.9905 3.23672 10.0427 4.0266Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.622 20.8627C11.9162 20.7839 12.2186 20.9585 12.2974 21.2526L12.4711 21.9011C12.6703 22.6443 13.5189 23.1343 14.2622 22.9351C15.0054 22.736 15.4954 21.8873 15.2962 21.1441L15.1225 20.4957C15.0437 20.2015 15.2183 19.8991 15.5125 19.8203C15.8066 19.7414 16.109 19.916 16.1879 20.2102L16.3616 20.8586C16.7184 22.1903 15.8793 23.6437 14.5476 24.0005C13.216 24.3573 11.7626 23.5182 11.4058 22.1865L11.232 21.5381C11.1532 21.2439 11.3278 20.9415 11.622 20.8627Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.2b34fe90b93e7056c9f90037b623d1cb.svg";
export { ForwardRef as ReactComponent };